var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasPermissionEx("view") }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasPermissionEx("view"),
              expression: "hasPermissionEx('view')"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("channel.channelNameText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                placeholder: _vm.$t("common.pleaseEnterText")
                              },
                              model: {
                                value: _vm.queryParameter.channelName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.queryParameter,
                                    "channelName",
                                    $$v
                                  )
                                },
                                expression: "queryParameter.channelName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("channel.organizationCodeText")
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                placeholder: _vm.$t("common.pleaseEnterText")
                              },
                              model: {
                                value: _vm.queryParameter.organizationCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.queryParameter,
                                    "organizationCode",
                                    $$v
                                  )
                                },
                                expression: "queryParameter.organizationCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("channel.gatewayTypeText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "common.pleaseSelectText"
                                  ),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.gatewayType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.queryParameter,
                                      "gatewayType",
                                      $$v
                                    )
                                  },
                                  expression: "queryParameter.gatewayType"
                                }
                              },
                              _vm._l(this.netwayCodeEnums, function(item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("channel.channelStatusText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "common.pleaseSelectText"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.channelStatus,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.queryParameter,
                                      "channelStatus",
                                      $$v
                                    )
                                  },
                                  expression: "queryParameter.channelStatus"
                                }
                              },
                              _vm._l(_vm.smsChannelStatusOptions, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "actions", staticStyle: { height: "60px" } },
                  [
                    _c(
                      "div",
                      { staticClass: "otherActions" },
                      [
                        _c(
                          "el-dropdown",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  plain: _vm.$store.getters.plainConf,
                                  type: "success",
                                  icon: "el-icon-plus"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("channel.channelOperationText")
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c("el-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.hasPermissionEx("add"),
                                          expression: "hasPermissionEx('add')"
                                        }
                                      ],
                                      staticClass: "dropdown-menu",
                                      on: {
                                        click: function($event) {
                                          _vm.addDialogVisible = true
                                        }
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-edit" }),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("channel.addChannelText")
                                            )
                                        )
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("el-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.hasPermissionEx("add"),
                                          expression: "hasPermissionEx('add')"
                                        }
                                      ],
                                      staticClass: "dropdown-menu",
                                      on: { click: _vm.handleUpdateCostCheck }
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-edit" }),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "channel.configureCostText"
                                              )
                                            )
                                        )
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("el-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.hasPermissionEx("add"),
                                          expression: "hasPermissionEx('add')"
                                        }
                                      ],
                                      staticClass: "dropdown-menu",
                                      on: { click: _vm.handleAddExistChannel }
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-edit" }),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "channel.createSimilarChannelText"
                                              )
                                            )
                                        )
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("el-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.hasPermissionEx("delete"),
                                          expression:
                                            "hasPermissionEx('delete')"
                                        }
                                      ],
                                      staticClass: "dropdown-menu",
                                      on: { click: _vm.handleBatchDelete }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete"
                                      }),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "channel.batchDeleteChannelText"
                                              )
                                            )
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasPermissionEx("view"),
                        expression: "hasPermissionEx('view')"
                      }
                    ],
                    key: _vm.tableKey,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.payChannelId"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.id
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.id))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.channelNameText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.channelName
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.channelName))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.organizationCodeText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.merchNo
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.merchNo))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.gatewayTypeText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertGatewayTypeOptionName(
                                      scope.row.netwayCode
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertGatewayTypeOptionName(
                                            scope.row.netwayCode
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.implementClassText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.implFullClass
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.implFullClass))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.weightingText"),
                        align: "center",
                        prop: "weight",
                        "min-width": _vm.customTableColumnWidth("sm")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.channelCostText"),
                        align: "center",
                        prop: "cost",
                        "min-width": _vm.customTableColumnWidth("sm")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.minimumAmountText"),
                        align: "center",
                        prop: "minAmount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.maximumAmountText"),
                        align: "center",
                        prop: "maxAmount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.requestUrlText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.requestUrl
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.requestUrl))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.settleDayText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.settleDay
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.settleDay))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.channelStatusText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertStatusOptionName(
                                      scope.row.stateCode
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertStatusOptionName(
                                            scope.row.stateCode
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("common.operationText"),
                        align: "center",
                        width: "220"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("update"),
                                      expression: "hasPermissionEx('update')"
                                    }
                                  ],
                                  staticClass: "filter-item",
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    round: _vm.$store.getters.roundConf,
                                    size: "mini",
                                    type: "warning",
                                    icon: "el-icon-edit"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleUpdateCheck(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.update")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("delete"),
                                      expression: "hasPermissionEx('delete')"
                                    }
                                  ],
                                  staticClass: "filter-item",
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    round: _vm.$store.getters.roundConf,
                                    size: "mini",
                                    type: "danger",
                                    icon: "el-icon-delete"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDelete(scope.row.id)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.delete")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermissionEx("view"),
                      expression: "hasPermissionEx('view')"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.queryParameter.pageNum,
                    limit: _vm.queryParameter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dialog" },
                  [
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          id: "dialog",
                          visible: _vm.addDialogVisible,
                          width: "700px",
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.addDialogVisible = $event
                          },
                          closed: _vm.handleResetAdd
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card" },
                          [
                            _c("div", { staticClass: "card-title" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm.updatePayChannelFlag
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.updatePayChannelText"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.updatePayChannelFlag
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("message.addPayChannelText")
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "close" }, [
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  on: { click: _vm.handleResetAdd }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form",
                              {
                                ref: "addInformation",
                                attrs: {
                                  model: _vm.addInformationParameter,
                                  rules: _vm.rules,
                                  "label-width": "220px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.channelNameText"),
                                      prop: "channelName"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter
                                            .channelName
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .channelName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "channelName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.channelName"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "channel.organizationCodeText"
                                      ),
                                      prop: "organizationCode"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter
                                            .organizationCode
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .organizationCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "organizationCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.organizationCode"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.gatewayTypeText"),
                                      prop: "gatewayType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "filter-item",
                                        attrs: {
                                          placeholder:
                                            _vm.addInformationParameter
                                              .gatewayType,
                                          clearable: "",
                                          filterable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.addInformationParameter
                                              .gatewayType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addInformationParameter,
                                              "gatewayType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addInformationParameter.gatewayType"
                                        }
                                      },
                                      _vm._l(this.netwayCodeEnums, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.display_name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "channel.implementClassText"
                                      ),
                                      prop: "implementClass"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter
                                            .implementClass
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .implementClass,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "implementClass",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.implementClass"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.weightingText"),
                                      prop: "weighting"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.weighting,
                                        type: "number",
                                        min: "0"
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter.weighting,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "weighting",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.weighting"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.channelCostText"),
                                      prop: "channelCost"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "filter-item",
                                        attrs: {
                                          placeholder:
                                            _vm.addInformationParameter
                                              .channelCost,
                                          type: "number",
                                          min: "0"
                                        },
                                        model: {
                                          value:
                                            _vm.addInformationParameter
                                              .channelCost,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addInformationParameter,
                                              "channelCost",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addInformationParameter.channelCost"
                                        }
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticStyle: {
                                              "font-style": "normal",
                                              "margin-right": "10px"
                                            },
                                            attrs: { slot: "suffix" },
                                            slot: "suffix"
                                          },
                                          [_vm._v(_vm._s("/" + this.costRatio))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "channel.minimumAmountText"
                                      ),
                                      prop: "minimumAmount"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter
                                            .minimumAmount,
                                        type: "number",
                                        min: "0"
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .minimumAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "minimumAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.minimumAmount"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "channel.maximumAmountText"
                                      ),
                                      prop: "maximumAmount"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter
                                            .maximumAmount,
                                        type: "number",
                                        min: "0"
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .maximumAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "maximumAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.maximumAmount"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.requestUrlText"),
                                      prop: "requestUrl"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.requestUrl
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .requestUrl,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "requestUrl",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.requestUrl"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.callbackUrlText"),
                                      prop: "callbackUrl"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter
                                            .callbackUrl
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .callbackUrl,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "callbackUrl",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.callbackUrl"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.tradeIDText"),
                                      prop: "tradeID"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.tradeID
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter.tradeID,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "tradeID",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.tradeID"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.signatureKeyText"),
                                      prop: "signatureKey"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter
                                            .signatureKey
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .signatureKey,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "signatureKey",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.signatureKey"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.encryptedKeyText")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter
                                            .encryptedKey
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .encryptedKey,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "encryptedKey",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.encryptedKey"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "channel.channelStatusText"
                                      ),
                                      prop: "channelStatus"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "filter-item",
                                        attrs: {
                                          placeholder: _vm.convertStatusOptionName(
                                            _vm.addInformationParameter
                                              .channelStatus
                                          ),
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.addInformationParameter
                                              .channelStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addInformationParameter,
                                              "channelStatus",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addInformationParameter.channelStatus"
                                        }
                                      },
                                      _vm._l(
                                        _vm.smsChannelStatusOptions,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.display_name,
                                            attrs: {
                                              label: item.display_name,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.settleDayText"),
                                      prop: "settleDay"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.settleDay,
                                        clearable: ""
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter.settleDay,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "settleDay",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.settleDay"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "KE1" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.KE1
                                      },
                                      model: {
                                        value: _vm.addInformationParameter.KE1,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "KE1",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.KE1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "KE2" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.KE2
                                      },
                                      model: {
                                        value: _vm.addInformationParameter.KE2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "KE2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.KE2"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "KE3" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.KE3
                                      },
                                      model: {
                                        value: _vm.addInformationParameter.KE3,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "KE3",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.KE3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "KE4" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.KE4
                                      },
                                      model: {
                                        value: _vm.addInformationParameter.KE4,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "KE4",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.KE4"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "KE5" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.KE5
                                      },
                                      model: {
                                        value: _vm.addInformationParameter.KE5,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "KE5",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.KE5"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "confirm-button" },
                              [
                                _c(
                                  "el-button",
                                  { on: { click: _vm.handleReset } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.reset")) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.buttonLoading,
                                        expression: "buttonLoading"
                                      }
                                    ],
                                    attrs: {
                                      type: "primary",
                                      disabled: _vm.buttonLoading
                                    },
                                    on: { click: _vm.handleAdd }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.submit")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }